import OrderManagerShipmentEdit from "./OrderManagerShipmentEdit";

export default class OrderManagerCreate extends OrderManagerShipmentEdit
{
    constructor(params)
    {
        super(params);

        this.additionalProperties = [];
        this.getAdditionalProperties().then(data => this.additionalProperties = data);
    }

    getAdditionalProperties()
    {
        return new Promise((resolve, reject) => {
            BX.ajax.runAction('lpost:delivery.api.OrderProperty.getAdditionalProperties')
                .then((res) => {
                    resolve(res.data)
                })
                .catch(res => {
                    reject(res.errors)
                })
        })
    }

    getLocationId()
    {
        return BX.Sale.Admin
            .OrderBuyer
            .propertyCollection
            .getDeliveryLocation()
            .getValue();
    }

    refresh()
    {
        BX.Sale.Admin.OrderAjaxer.sendRequest(
            BX.Sale.Admin.OrderEditPage.ajaxRequests.refreshOrderData()
        );
    }

    renderAddress(value)
    {
        let addressObject;

        if(addressObject = this.getAddressObject()) {
            addressObject.setValue(value);
        }
    }

    renderAdditionalField(value, code) {
        if (!this.additionalProperties) {
            return false;
        }

        this.additionalProperties.forEach(e => {
            if (e.CODE === code) {
                let fieldObject = BX.Sale.Admin
                    .OrderBuyer
                    .propertyCollection
                    .getById();
                fieldObject.setValue(value);
            }
        });
    }

    getPersonTypeId()
    {
        let personType = BX.Sale.Admin.OrderBuyer
        return personType.getBuyerId() ?? false;
    }

    getAddressObject()
    {
        let addressObject = BX.Sale.Admin
            .OrderBuyer
            .propertyCollection
            .getAddress();

        if(addressObject) {
            return addressObject
        }

        return false;
    }

    getAddressNode()
    {
        let addressObject;

        if(addressObject = this.getAddressObject()) {
            return this.getAddressObject().getParentNode();
        }

        return false;
    }
}


